import React from 'react'
import { allTheOtherFields, mostCommonFieldsList } from './RequiredFieldsValues'
import styles from './styles.module.css'
import externalLinkIcon from './images/arrow-up-right-from-square.svg'
import Tooltip from '@mui/material/Tooltip'
import infoIcon from './../images/circle-info-regular-full.svg'


function RequiredFields ({ localRequiredFields, setLocalRequiredFields }) {
  const handleChangeRequiredFields = fieldValue => {
    setLocalRequiredFields(prevSelectedFields => {
      const newSelectedFields = prevSelectedFields.includes(fieldValue)
        ? prevSelectedFields.filter(value => value !== fieldValue)
        : [...prevSelectedFields, fieldValue]

      return newSelectedFields
    })
  }

  const SCHEMA_URL = 'https://docs.datafiniti.co/docs/business-data-schema'

  return (
    <section className={styles.requiredFieldsSection}>
    <div className={styles.titleWithIcon}>
  <h1 className={styles.requiredFieldsTitle}>Required fields</h1>
  <Tooltip
    title="Only return business records that include all selected fields."
    arrow
    placement="top"
    slotProps={{
      popper: {
        sx: {
          '& .MuiTooltip-tooltip': {
            maxWidth: 500,
            fontSize: '13px',
            padding: '8px',
          },
        },
      },
    }}
  >
    <img
      src={infoIcon}
      alt="Required fields help"
      width={14}
      height={14}
      className={styles.infoIcon}
      tabIndex={0}
    />
  </Tooltip>
</div>

      <div className={styles.requiredFieldsInline}>
        <p className={styles.mostRequiredFieldsTitle}>
          Select fields that must be filled out in each record. See data schema
          for more information.
        </p>
        <a
          href={SCHEMA_URL}
          target='_blank'
          rel='noopener noreferrer'
          className={styles.schemaLink}
          aria-label='Open data schema'
        >
          <img src={externalLinkIcon} alt='' />
        </a>
      </div>

      <div style={{ marginBottom: '14px' }}>
        <h2 className={styles.requiredField2}>Common fields</h2>
        <div className={styles.requiredFieldsRow}>
          {mostCommonFieldsList.map((field, index) => (
            <div key={index} className={styles.checkboxContainer}>
              <input
                type='checkbox'
                id={field.value}
                name={field.value}
                className={styles.customCheckbox}
                checked={localRequiredFields.includes(field.value)}
                onChange={() => handleChangeRequiredFields(field.value)}
              />
              <label
                htmlFor={`${field.value}RequiredField`}
                className={styles.customLabel}
              >
                {field.label}
              </label>
            </div>
          ))}
        </div>
      </div>

      <div>
        <h2 className={styles.requiredField2}>All other fields</h2>
        <div className={styles.requiredFieldsRow}>
          {allTheOtherFields.map((field, index) => (
            <div key={index} className={styles.checkboxContainer}>
              <input
                type='checkbox'
                id={field.value}
                name={field.value}
                className={styles.customCheckbox}
                checked={localRequiredFields.includes(field.value)}
                onChange={() => handleChangeRequiredFields(field.value)}
              />
              <label
                htmlFor={`${field.value}RequiredField`}
                className={styles.customLabel}
              >
                {field.label}
              </label>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default RequiredFields
